import script from "./FranchiseProductLibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseProductLibrary.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import EmptyState from "@/components/neue/EmptyState.vue";
import FranchiseMenuControls from "@/components/franchise/FranchiseMenuControls.vue";
import FranchiseMenuSetupCard from "@/components/franchise/FranchiseMenuSetupCard.vue";
import FranchiseMerchantSwitcher from "@/components/franchise/FranchiseMerchantSwitcher.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
script.components = Object.assign({}, { EmptyState, FranchiseMenuControls, FranchiseMenuSetupCard, FranchiseMerchantSwitcher, SecondaryNav, SecondaryTop }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { EmptyState, FranchiseMenuControls, FranchiseMenuSetupCard, FranchiseMerchantSwitcher, SecondaryNav, SecondaryTop }, script.__o.components);}